import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import DomesticRefundForRefundOfRefundsViewModel from "viewModels/finance/refundForRefundOfRefunds/transferRefundForRefundOfRefunds/domestic/domesticRefundForRefundOfRefundsViewModel";
import { TransferRefundForRefundOfRefundsView } from "../transferRefundForRefundOfRefundsView";

const DomesticRefundForRefundOfRefundsView: ViewComponent<DomesticRefundForRefundOfRefundsViewModel> = observer(({ vm }) => (
  <TransferRefundForRefundOfRefundsView key={vm.name} vm={vm} />
));

registerView(DomesticRefundForRefundOfRefundsView, DomesticRefundForRefundOfRefundsViewModel);
